import { useEffect, useRef, useState } from "react";
import cls from "classnames";

import CrossIcon from "components/icons/CrossIcon";

export function WrappedMultiInput(props) {
  const [showInput, setShowInput] = useState(false);

  const { label } = props;

  return showInput ? <MultiInput {...props}/> : (
    <button
        onClick={() => setShowInput(true)}
        className="text-primary appearance-none font-semibold"
      >
        {`+ ${label}`}
      </button>
  )
}

export default function MultiInput(props) {
  const {
    type,
    name,
    placeholder,
    primaryColor,
    label,
    value,
    onChange,
    autoComplete,
    required,
    disabled,
    autoFocus,
    onBlur,
  } = props;

  const [valuesArray, setValuesArray] = useState([]);

  const inputRef = useRef(null);

  useEffect(() => {
    const valueString = valuesArray.join(",");

    onChange({
      target: {
        name,
        value: valueString,
      },
    });
  }, [JSON.stringify(valuesArray)]);

  function addValueToArray(value) {
    if (!value) return;

    const trimmedValue = value.trim();

    if (!valuesArray.find((val) => val === trimmedValue)) {
      setValuesArray((prev) => [...prev, trimmedValue]);
    }
  }

  function handleKeyDown(ev) {
    const value = ev.target.value.trim();

    if (["Enter", "Tab", ","].includes(ev.key)) {
      ev.preventDefault();

      if (value) {
        addValueToArray(value);
        inputRef.current.value = "";
      }
    }

    if (["Backspace", "Delete"].includes(ev.key)) {
      if (!value.length) {
        ev.preventDefault();

        setValuesArray((prev) => [...prev.slice(0, prev.length - 1)]);
        inputRef.current.value = "";
      }
    }
  }

  function handleDelete(value) {
    const newValuesArray = valuesArray.filter((_value) => _value !== value);

    setValuesArray(newValuesArray);
    inputRef.current.value = "";
  }

  const handleOnBlur = (ev) => {
    const value = ev.target.value.trim();

    addValueToArray(value);
    inputRef.current.value = "";

    onBlur && onBlur(ev);
  };

  function handleOnPaste(ev) {
    ev.preventDefault();
    const clipboardText = ev.clipboardData.getData("text");

    const values = clipboardText.split(",");

    values.forEach((val) => addValueToArray(val));
    inputRef.current.value = "";
  }

  function focusInputEl() {
    inputRef.current.focus();
  }


  return (
    <div className={cls("flex flex-col items-start w-full")}>
      {label && <div className="mb-1 font-semibold text-sm">{label}</div>}
      <div
        className="w-full bg-white border-[#D5D8DC] border rounded min-h-[2.75rem] px-3"
        onClick={focusInputEl}
      >
        {valuesArray?.length > 0 && (
          <div
            onClick={focusInputEl}
            className="flex flex-wrap items-center gap-2 pt-3"
          >
            {valuesArray.map((value) => (
              <span
                key={value}
                className={cls(
                  "text-sm flex items-center gap-1 text-white py-1 px-2 rounded bg-primary select-none"
                )}
              >
                {value}
                <button onClick={() => handleDelete(value)}>
                  <CrossIcon className="w-4" fill="#fff" />
                </button>
              </span>
            ))}
          </div>
        )}
        <input
          ref={inputRef}
          className={cls(
            "bg-transparent w-full min-w-[50%] h-11 text-sm flex-1",
            "placeholder-[#22272B] placeholder-opacity-20",
            "outline-none focus:outline-none disabled:cursor-not-allowed"
          )}
          name={name}
          type={type}
          placeholder={placeholder}
          onKeyDown={handleKeyDown}
          onBlur={handleOnBlur}
          onPaste={handleOnPaste}
          autoFocus={autoFocus}
          autoComplete={autoComplete}
          disabled={disabled}
          required={required}
        />
      </div>
    </div>
  );
}
